import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import SearchScreen from "../screens/SearchScreen";
import NameDetailsScreen from "../screens/NameDetailsScreen";
import { useTranslation } from "../hooks/useTranslation";

const Stack = createStackNavigator();

const SearchStackNavigator = () => {
  const { getTranslation } = useTranslation();

  return (
    <Stack.Navigator
      screenOptions={{
        headerTitleStyle: {
          fontFamily: "Urbanist_700Bold",
          fontSize: 20,
          color: "#333",
        },
        headerStyle: {
          backgroundColor: "#F9FAFB",
        },
      }}
    >
      <Stack.Screen
        name="Search"
        component={SearchScreen}
        options={{ headerTitle: getTranslation("searchTitle") }}
      />
      <Stack.Screen
        name="NameDetails"
        component={NameDetailsScreen}
        options={{ headerTitle: getTranslation("nameDetailsTitle") }}
      />
    </Stack.Navigator>
  );
};

export default SearchStackNavigator;